import React, { useState } from "react";
import { CheckCircle2, XCircle, RotateCcw, Loader2, Award } from "lucide-react";
import { toast } from "sonner";
import { apiError } from "../../lib/api";

const Option = ({ text, selected, state, onClick, testid }) => {
  const base = "w-full text-left px-4 py-3 rounded-xl text-sm font-semibold ring-1 transition-colors";
  const cls = state === "ok" ? "bg-[#E7F6EE] ring-[#1E9E5A] text-[#0F5132]"
    : state === "bad" ? "bg-[#FFD9D9] ring-[#D64545] text-[#6B0F17]"
    : selected ? "bg-[#0A1C30] ring-[#0A1C30] text-white" : "bg-white ring-black/10 text-[#0A1C30] hover:ring-[#B99B2E]";
  return <button type="button" data-testid={testid} onClick={onClick} className={`${base} ${cls}`}>{text}</button>;
};

export const QuizBox = ({ preguntas, onSubmit, aprobadoPrevio, onPassed }) => {
  const [resp, setResp] = useState({});
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);
  const complete = preguntas.every((_, i) => resp[i] !== undefined);

  const submit = async () => {
    setBusy(true);
    try {
      const r = await onSubmit(preguntas.map((_, i) => resp[i]));
      setResult(r);
      if (r.aprobado) { toast.success(`¡Aprobado! ${r.nota}/${r.total}`); onPassed && onPassed(r); }
      else toast.error(`Obtuviste ${r.nota}/${r.total}. Necesitas ${r.minimo}. ¡Inténtalo de nuevo!`);
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  const retry = () => { setResp({}); setResult(null); };

  return (
    <div className="mt-10 rounded-3xl bg-[#0A1C30] p-5 sm:p-7 text-white" data-testid="cap-quiz">
      <div className="flex items-center gap-3 flex-wrap">
        <Award className="w-6 h-6 text-[var(--gold)]" />
        <h3 className="text-lg font-extrabold">Evaluación del módulo</h3>
        <span className="text-xs text-white/60">Aprueba con 4 de 5 · intentos ilimitados</span>
        {aprobadoPrevio && <span className="ml-auto text-xs font-bold bg-[#1E9E5A] px-3 py-1 rounded-full" data-testid="cap-quiz-prev-passed">Ya aprobado</span>}
      </div>
      <ol className="mt-6 space-y-6">
        {preguntas.map((p, i) => (
          <li key={i} data-testid={`cap-q-${i}`}>
            <div className="font-bold text-sm mb-3"><span className="text-[var(--gold)] mr-2">{i + 1}.</span>{p.pregunta}</div>
            <div className="grid sm:grid-cols-2 gap-2">
              {p.opciones.map((o, j) => {
                const sel = resp[i] === j;
                const state = result && sel ? (result.detalle[i] ? "ok" : "bad") : null;
                return <Option key={j} text={o} selected={sel} state={state} testid={`cap-q-${i}-opt-${j}`} onClick={() => !result && setResp({ ...resp, [i]: j })} />;
              })}
            </div>
          </li>
        ))}
      </ol>
      {result ? (
        <div className="mt-7 flex flex-wrap items-center gap-4" data-testid="cap-quiz-result">
          {result.aprobado ? <CheckCircle2 className="w-8 h-8 text-[#3DDC84]" /> : <XCircle className="w-8 h-8 text-[#FF6B6B]" />}
          <div>
            <div className="text-2xl font-extrabold" data-testid="cap-quiz-score">{result.nota}/{result.total}</div>
            <div className="text-sm text-white/70">{result.aprobado ? "¡Módulo aprobado! Sigue avanzando." : `Necesitas ${result.minimo} correctas. Repasa el contenido y vuelve a intentarlo.`}</div>
          </div>
          <button data-testid="cap-quiz-retry" onClick={retry} className="ml-auto inline-flex items-center gap-2 rounded-xl bg-white/10 hover:bg-white/20 px-5 py-3 font-bold text-sm transition-colors">
            <RotateCcw className="w-4 h-4" /> Reintentar
          </button>
        </div>
      ) : (
        <button data-testid="cap-quiz-submit" disabled={!complete || busy} onClick={submit} className="mt-7 inline-flex items-center gap-2 rounded-xl bg-[var(--gold)] text-[#0A1C30] font-extrabold px-6 py-3 disabled:opacity-40 hover:brightness-105 transition">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Enviar respuestas
        </button>
      )}
    </div>
  );
};
